import { render, staticRenderFns } from "./NavBar_phone.vue?vue&type=template&id=6bb18f34&scoped=true&"
import script from "./NavBar_phone.vue?vue&type=script&lang=js&"
export * from "./NavBar_phone.vue?vue&type=script&lang=js&"
import style0 from "./NavBar_phone.vue?vue&type=style&index=0&id=6bb18f34&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb18f34",
  null
  
)

export default component.exports